<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P96O4E/tc-custom/9780795346743.jpg?1734327498293" alt="This image is the cover for the book Never Again"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Never Again
      </h1>
      <p class="bookDescription body article font2">
        <b>A work forty years in the making—Sir Martin Gilbert’s illustrated survey of the pre- and post-war history of the Jewish people in Europe.</b><br/>  <br/> Masterfully covering such topics as pre-war Jewish life, the Warsaw Ghetto revolt, and the reflections of Holocaust survivors, Gilbert interweaves firsthand accounts with unforgettable photographs and documents, which come together to form a three-dimensional portrait of the lives of the Jewish people during one of Europe’s darkest times.<br/>  <br/> “This volume introduces the crime to a new generation, so that it knows of the atrocities and the seemingly futile acts of defiance taken, in the words of Judah Tenenbaum, ‘for three lines in the history books.’” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Gilbert
      </h2>
      
      <p class="authorDescription body article">SIR MARTIN GILBERT was born in England in 1936. He was a graduate of Oxford University, from which he held a Doctorate of Letters, and was an Honorary Fellow of Merton College, Oxford. In 1962 he began work as one of Randolph Churchill’s research assistants, and in 1968, after Randolph Churchill’s death, he became the official biographer of Winston Churchill. He published six volumes of the Churchill biography, and edited twelve volumes of Churchill documents. During forty-eight years of research and writing, Sir Martin published eighty books, including <I>The First World War, The Second World War, </I>and a three-volume <I>History of the Twentieth Century. </I>He also wrote, as part of his series of ten historical atlases, <I>Atlas of the First World War, </I>and, most recently, <I>Atlas of the Second World War.</I> Sir Martin’s film and television work included a documentary series on the life of Winston Churchill. His other published works include <I>Churchill: A Photographic Portrait, In Search of Churchill, Churchill and America, </I>and the single volume <I>Churchill, A Life.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54c4e4f3